// Generated by scripts/generate-app-version.mjs.
export const APP_RELEASE = {
  "version": "1.0.0",
  "buildId": "20261104T214037475Z",
  "builtAt": "2026-11-04T21:40:37.475Z"
} as const;
